module.exports = __webpack_public_path__ + "img/bg_8.867f2827.png";